class GlobalModalJs extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      button: '[global-modal-btn]',
      modal: '[global-modal-js]',
    };

    this.init();
  }

  init() {
    const buttons = document.querySelectorAll(this.selectors.button);
    const modals = this.querySelectorAll(this.selectors.modal);
    console.log(buttons, modals)
    if (!buttons.length || !modals.length) return;

    buttons?.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const modalEle = this.querySelector(`${this.selectors.modal}[data-id="${button.dataset.id}"]`);
        console.log("clicked", button, modalEle, `${this.selectors.modal}[data-id="${button.dataset.id}"]`);
        if (modalEle) {
          const modal = new tingle.modal({
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: 'Close',
            cssClass: ['tingle-modal--shopify'],
          });
          modal.setContent(modalEle.innerHTML);
          modal.open();
        }
      });
    });
  }
}
customElements.define('global-modal-js', GlobalModalJs);